import { type ReactNode, type PropsWithChildren, useEffect } from 'react'
import { type PermissionType, type SingleOrOptionalEntityIds, isDefined, isNotDefined } from '@terros/common'
import { useNavigate } from '@tanstack/react-router'
import { showNotification } from '@mantine/notifications'
import { usePermissionCheck } from '@front/model'

type Props = PropsWithChildren<{
  targetId: SingleOrOptionalEntityIds | undefined
  permissionType: PermissionType
  navigationTo?: string
}>

export const PermissionCheckWrapper = ({ targetId, permissionType, navigationTo, children }: Props): ReactNode => {
  const { data: hasPermission, isLoading, error } = usePermissionCheck({ targetId, permissionType })
  const navigate = useNavigate()

  useEffect(() => {
    if (isDefined(hasPermission) && navigationTo) {
      if (!hasPermission) {
        if (navigationTo === 'parent') {
          navigate({ to: '..' })
        } else {
          navigate({ to: navigationTo })
        }
        showNotification({ message: 'You do not have permission to view this page', color: 'red' })
      }
    }
  }, [hasPermission, navigate, navigationTo])

  if (isLoading || isNotDefined(hasPermission) || error) return

  if (!hasPermission) return

  return children
}
